import Widget from "../Widget";
import { ewent, observe } from "../../reactive";
import jquery from "jquery";
export default class Button extends Widget {
    constructor(container = jquery("<div>")) {
        super(container);
        this.clicked = ewent();
        this.enabled = observe(true);
        this.toggled = observe(false);
        this.isToggleable = observe(false);
        this.addClass("lcss-button");
        this.container.on("click", (e) => {
            e.stopPropagation();
            if (!this.container.hasClass("enabled"))
                return;
            if (this.isToggleable.value())
                this.toggled.set(!this.toggled.value());
            this.clicked.trigger(e);
        });
        this.enabled.subscribe(v => {
            this.toggleClass("enabled", v);
        }, true);
        this.toggled.subscribe(v => {
            this.toggleClass("toggled", v);
        });
        this.isToggleable.subscribe(v => {
            if (!v)
                this.toggled.set(false);
        });
        this.setEnabled(true);
    }
    setEnabled(value) {
        this.enabled.set(value);
        if (!value)
            this.toggled.set(false);
        return this;
    }
    onClick(handler, pool = null) {
        let h = this.clicked.on(handler);
        pool?.bind(h);
        return this;
    }
    onToggle(handler) {
        this.toggled.subscribe(handler);
        return this;
    }
    setToggleable(v) {
        this.isToggleable.set(v);
        return this;
    }
    setToggled(b) {
        this.toggled.set(b);
        return this;
    }
    click() {
        return this.raw().click();
    }
}
